import { FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS } from 'pages/FundInvestments/common/constants';
import { normalizeHiddenCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizeHiddenCell';
import { normalizePercentageCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizePercentageCell';
import { HandleMeanMedianCellsParams } from './handleMeanMedianCells.types';

const { metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE, percentage_change: PERCENTAGE_CHANGE }
  = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const handleMeanMedianCells = (params: HandleMeanMedianCellsParams): void => {
  const { allComparisonsExpression, cell, colNumber, formula, key, title } = params;

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      Object.assign(cell, {
        className: `${cell.className} read-only--white`,
        hidden: false,
        value: title,
      });
      break;

    case PERCENTAGE_CHANGE.column:
      normalizePercentageCell(cell);

      Object.assign(cell, {
        customKey: key,
        expr: `=${formula}(FILTER_ENABLED([${allComparisonsExpression}]))`,
      });
      break;

    default:
      normalizeHiddenCell(cell);
      break;
  }
};

export default handleMeanMedianCells;
